import type Theme from '@jetbrains/ring-ui/components/global/theme'

import {UserProperties} from '../../utils/userProperties'
import {useAppSelector} from '../react-redux'
import {useUserProperty} from '../useUserProperty'

export function useUserTheme(): Theme {
  const initialTheme = useAppSelector(state => state.initialTheme)
  const userPropertyTheme = useUserProperty(UserProperties.THEME) as Theme | null | undefined
  return userPropertyTheme ?? initialTheme
}
